import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const getBrands = createAsyncThunk(
  "brand/getBrands",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/brands?search=${data.search}&filter=${data.filter}&perPage=${data.perPage}&page=${data.page}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to get brand.");
    }
  }
);

export const addBrand = createAsyncThunk(
  "brand/addBrand",
  async (data, { rejectWithValue }) => {
    try {
      let formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (key === 'image' && !(value instanceof File)) {
          formData.append(key, '');
        } else {
          formData.append(key, value);
        }
      });

      let url = "admin/brands";
      if (data.id) {
        url += `/${data.id}`;
      }
      const response = await api.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to add brand");
    }
  }
);

export const deleteBrand = createAsyncThunk(
  "brand/deleteBrand",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.del(`admin/brands/${id}`);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to delete brand");
    }
  }
);

export const changeBrandStatus = createAsyncThunk(
  "brand/changeBrandStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await api.post(`admin/brands/${id}/status`, { status });
      return response;
    } catch (error) {
      console.error("Change status error:", error);
       return rejectWithValue(err.response?.data || "Failed to change status");
    }
  }
);

export const downloadBrandCSV = createAsyncThunk(
  "brand/downloadBrandCSV",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/export-brands`);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to export brands");
    }
  }
);

const brandSlice = createSlice({
  name: "brand",
  initialState: {
    list_brand: [],
    selected: null,
    loading: false,
    list_loading: false,
    status: "idle",
  },
  reducers: {
    setSelectedBrand(state, action) {
      state.selected = action.payload;
    },
    unsetSelectedBrand(state) {
      state.selected = null;
    },
    resetStatus(state) {
      state.loading = false,
      state.list_loading = false
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(getBrands.pending, (state) => {
      state.list_loading = true;
    })
    .addCase(getBrands.fulfilled, (state, action) => {
      state.list_loading = false;
      state.list_brand = action.payload;
    })
    .addCase(getBrands.rejected, (state) => {
      state.list_loading = false;
    })
    .addCase(addBrand.pending, (state) => {
      state.loading = true;
    })
    .addCase(addBrand.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(addBrand.rejected, (state) => {
      state.loading = false;
    })
    .addCase(deleteBrand.pending, (state) => {
      state.loading = true;
    })
    .addCase(deleteBrand.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(deleteBrand.rejected, (state) => {
      state.loading = false;
    })
    .addCase(changeBrandStatus.pending, (state) => {
      state.loading = true;
    })
    .addCase(changeBrandStatus.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(changeBrandStatus.rejected, (state) => {
      state.loading = false;
    })
      .addCase(downloadBrandCSV.pending, (state) => {
        state.loading = true;
      })
      .addCase(downloadBrandCSV.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(downloadBrandCSV.rejected, (state) => {
        state.loading = false;
      }); 
  },
});

export const { setSelectedBrand, unsetSelectedBrand, resetStatus } = brandSlice.actions;
export default brandSlice.reducer;
